module.exports = __webpack_public_path__ + "img/image.95740f33.svg";